export const firmInfo = {
  name: 'Bufete Ramos Santos',
  attorney: 'León Felipe Ramos Santos',
  phone: '+506 8322-2424',
  email: 'leferasa@hotmail.com',
  address: '75 m Oeste Correos de Costa Rica, Heredia, Heredia, 40101, Costa Rica',
  hours: 'Lun – Vie, 7:30 AM – 6:00 PM',
};

export const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Sobre Nosotros', href: '/about' },
  { label: 'Servicios', href: '/about#servicios' },
  { label: 'Contacto', href: '/about#contacto' },
];

export const practiceAreas = [
  { icon: 'ri-home-heart-line', title: 'Derecho de Familia', href: '/about#familia', desc: `• Divorcio
• Pensión alimentaria
• Procesos de interrelación familiar
• Procesos de pérdida o supensión de la responsabilidad parental
• Procesos de filiación
• Procesos de violencia doméstica, entre otros.` },
  { icon: 'ri-file-list-3-line', title: 'Derecho Penal', href: '/about#penal', desc: `• Asesoría jurídica desde el inicio de una investigación penal.
• Defensa y representación de personas imputadas.
• Representación y acompañamiento de víctimas.
• Asistencia en declaraciones y diligencias judiciales.
• Análisis de investigaciones y valoración de la prueba.
• Preparación y seguimiento de estrategias de defensa.
• Acompañamiento durante las diferentes etapas del proceso penal.` },
  { icon: 'ri-building-line', title: 'Derecho Civil', href: '/about#civil', desc: `• Redacción, revisión y asesoría en materia de contratos.
• Procesos sucesorios.
• Procesos monitorios dinerarios.
• Procesos monitorios arrendaticios.
• Procesos sumarios de desahucio.
• Procesos ordinarios.
• Procesos de ejecución.
• Interdictos.
• Tercerías.
• Procesos de deslinde y desmarcación de linderos.
• Localización de derechos indivisos.
• Conflictos relacionados con obligaciones, bienes, propiedad y relaciones contractuales.` },
  { icon: 'ri-briefcase-4-line', title: 'Derecho Notarial', href: '/about#notarial', desc: `• Compraventa de propiedades y vehículos.
• Traspasos de bienes muebles e inmuebles.
• Constitución y cancelación de hipotecas.
• Constitución de sociedades mercantiles.
• Protocolización de actas.
• Otorgamiento de poderes generales y especiales.
• Matrimonios civiles.
• Divorcios y sucesiones en sede notarial.
• Testamentos.
• Declaraciones juradas.
• Autenticación de firmas.
• Certificaciones notariales.
• Segregación y reunión de propiedades.
• Constitución de servidumbres.
• Donaciones de bienes muebles e inmuebles.` },
];

export const stats = [
  { value: '25+', label: 'Años en práctica profesional' },
  { value: '2,300', label: 'Clientes representados' },
  { value: '4.9', label: 'Calificación promedio de los clientes' },
];

export const credentials: string[] = [];